import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// Atalhos de navegação estilo "g + letra" (vim-like) — pressione G, depois
// a letra destino em até 900ms. Funciona fora de inputs.
const ROUTES: Record<string, string> = {
  d: '/',
  c: '/cursos',
  l: '/lousas',
  o: '/obsidian',
  i: '/integracoes',
  g: '/glossario',
  a: '/auditoria',
  t: '/configuracoes/tokens',
};

function isEditable(el: EventTarget | null): boolean {
  if (!(el instanceof HTMLElement)) return false;
  const tag = el.tagName;
  return (
    tag === 'INPUT' ||
    tag === 'TEXTAREA' ||
    tag === 'SELECT' ||
    el.isContentEditable
  );
}

export function useGlobalKeybindings(onCmdK: () => void): void {
  const navigate = useNavigate();
  const gPressedAt = useRef<number>(0);

  useEffect(() => {
    function onKey(e: KeyboardEvent): void {
      // Cmd+K / Ctrl+K abre busca
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        onCmdK();
        return;
      }
      if (isEditable(e.target)) return;

      if (e.key === 'g' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        gPressedAt.current = Date.now();
        return;
      }

      if (gPressedAt.current && Date.now() - gPressedAt.current < 900) {
        const dest = ROUTES[e.key.toLowerCase()];
        if (dest) {
          e.preventDefault();
          gPressedAt.current = 0;
          navigate(dest);
          return;
        }
      }
    }

    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [navigate, onCmdK]);
}

export const KEYBINDINGS_HELP: Array<{ keys: string; description: string }> = [
  { keys: '⌘K', description: 'Abrir busca global' },
  { keys: 'G D', description: 'Ir pra Dashboard' },
  { keys: 'G C', description: 'Ir pra Cursos' },
  { keys: 'G L', description: 'Ir pra Lousas' },
  { keys: 'G O', description: 'Ir pra Obsidian' },
  { keys: 'G I', description: 'Ir pra Integrações' },
  { keys: 'G G', description: 'Ir pra Glossário' },
  { keys: 'G A', description: 'Ir pra Auditoria' },
  { keys: 'G T', description: 'Ir pra Tokens' },
];
